import { render, staticRenderFns } from "./ContactPicker.vue?vue&type=template&id=4e97546b&"
import script from "./ContactPicker.vue?vue&type=script&lang=js&"
export * from "./ContactPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports